import type { DetailListProps } from './DetailList.types';

export function DetailList(props: DetailListProps) {
  return <ul className={`list-disc pl-4 ${props.className}`}>{props.children}</ul>;
}
